export const PLACARD_CATALOGS: any = {
    PLACARD_SIZE: 'PLACARD_SIZE',
    PLACARD_LOCATION: 'PLACARD_LOCATION',
    PLACARD_TYPE: 'PLACARD_TYPE',
    PICKUP_LOCATION: 'PICKUP_LOCATION'
};
